var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69336 26.1339V26.0939V25.7873V25.7451V26.1339ZM6.69336 26.1339V21.7073C6.69336 21.7073 7.62669 16.8939 12.52 13.9473H19.5867C19.5867 13.9473 25.5467 18.5206 25.3734 21.9739V26.2273H21.5867L20.8267 25.2539H11.08L10.3067 26.1339H6.69336Z",
    stroke: "#484848",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2257 11.8535H12.6523V13.4802H15.2257V11.8535Z",
    fill: "#484848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3056 17.668H12.5723V19.468H14.3056V17.668Z",
    fill: "#484848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9052 17.668H15.1719V19.468H16.9052V17.668Z",
    fill: "#484848"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4658 17.668H17.7324V19.468H19.4658V17.668Z",
    fill: "#484848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3056 20.2949H12.5723V22.0949H14.3056V20.2949Z",
    fill: "#484848"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9052 20.2949H15.1719V22.0949H16.9052V20.2949Z",
    fill: "#484848"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4658 20.2949H17.7324V22.0949H19.4658V20.2949Z",
    fill: "#484848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3253 12.668H14.752V14.2946H17.3253V12.668Z",
    fill: "#484848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4522 11.8535H16.8789V13.4802H19.4522V11.8535Z",
    fill: "#484848"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2893 6.75219L10.6927 12.2675L6.18607 13.6275L6.05273 8.98751C6.05273 8.98751 15.9921 2.861 25.9327 9.52084L25.8927 13.5742L21.3291 12.0542L19.659 6.81886L12.2893 6.75219Z",
    stroke: "#484848",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumber);
export default __webpack_public_path__ + "static/media/PhoneNumber.4898f6bdecf64f7f4dc5f709b395d48b.svg";
export { ForwardRef as ReactComponent };